module.exports = __webpack_public_path__ + "static/media/reactjs.7cdcafa3.svg";